/* Ozzi journey page. One IntersectionObserver for the four explainer sections.

   It does two things and nothing else: adds `is-in` to a section the first time half of
   it is on screen (which starts that panel's CSS animations), and runs any
   `data-ozj-start` hook the section registered on window.ozj. Reduced motion still adds the
   class, so the header fades are skipped by CSS but the panels' finished states show. */
(function () {
  'use strict';
  var sections = document.querySelectorAll('.ozj[data-ozj]');
  if (!sections.length) return;
  window.ozj = window.ozj || {};

  function enter(el) {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-in');
    var hook = window.ozj[el.getAttribute('data-ozj')];
    if (typeof hook === 'function') hook(el);
  }

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(sections, enter);
    return;
  }
  // Every panel waits until half of it is on screen before it starts (Brandon, 2026-09-09:
  // all the animations wait for the same point). A section can override with
  // data-ozj-at. The ask is capped to what can actually fit, so a section taller than
  // the viewport still fires on a short phone instead of waiting forever.
  function wanted(el) {
    var at = parseFloat(el.getAttribute('data-ozj-at')) || 0.5;
    var fits = (window.innerHeight * 0.85) / Math.max(1, el.offsetHeight);
    return Math.min(at, fits);
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= wanted(e.target)) { enter(e.target); io.unobserve(e.target); }
    });
  }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7], rootMargin: '0px' });
  Array.prototype.forEach.call(sections, function (s) { io.observe(s); });
})();

/* Shop Now skip links: smooth-scroll to the buy box instead of a hard jump. The href stays
   "#build", so the link still works with this script blocked. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ozj-shop__btn');
    if (!a) return;
    var target = document.getElementById('build');
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();
